<template>
    <div>
        <div v-if="showEventLog" class="popup">
            <div class="popup-header d-flex justify-content-between align-items-center mb-2">
                <div class="me-2">
                    <h2>{{ $t('dataheaders.activitylog') }} {{ deviceName }}</h2>
                </div>
                <div class="ms-auto">
                    <button @click="closePopup" class="btn-close" aria-label="Close"></button>
                </div>
            </div>
            <div class="popup-content">
                <ul>
                    <li v-for="activity in eventLog" :key="activity.timestamp">{{ formattedTime(activity.timestamp) }}
                        {{ activity.message }}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
const { getCookie, formattedTime } = require('@/helpers');
import axios from 'axios';

export default {
    props: {
        showEventLog: {
            type: Boolean,
            default: false
        },
        deviceName: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            eventLog: []
        };
    },
    watch: {
        showEventLog(newVal) {
            if (newVal) {
                this.fetchEventLog();
            }
        }
    },
    methods: {
        closePopup() {
            this.$emit('close-popup');
        },
        fetchEventLog() {
            const token = getCookie('token');
            axios.get(`${this.$url}/activitylog`, {
                params: {
                    device: this.deviceName
                },
                headers: {
                    Authorization: 'Bearer ' + token,
                    ContentType: 'application/json'
                }
            })
                .then(response => {
                    this.eventLog = response.data;
                })
                .catch(error => {
                    console.error('Failed to fetch activity log data:', error);
                });
        },
        formattedTime
    },
};
</script>

<style>
.popup {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    padding: 20px;
    border: 1px solid #ccc;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    max-height: 80vh;
    /*overflow-y: auto;*/
    display: flex;
    flex-direction: column;
    width: 90vw;
    max-width: 600px;
}

.popup-header {
    position: sticky;
    top: 0;
    background: white;
    z-index: 2;
    padding-bottom: 8px;
    border-bottom: 1px solid #eee;
}
.popup-content {
    overflow-y: auto;
    flex: 1 1 auto;
    min-height: 0;
}

.close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
}
</style>